import { Routes, RouterModule } from '@angular/router';
import { DelivererResourceList } from './delivererresource.list';

export const routes: Routes = [
    { path: 'page/delivererresource', component: DelivererResourceList },

    { path: '', redirectTo: 'page/delivererresource', pathMatch: 'full' },
];

export const DELIVERERRESOURCE_ROUTER_PROVIDERS = RouterModule.forRoot(routes);
